module Meevo.Plugins.MembershipManager {
    "use strict";

    /**
    * History Section
    */
    export class HistorySection extends MembershipBaseSection {
        public disableCrud: boolean = true;
        public disableAuditHistory = true;

    }
}
